var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarWeek(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1588_15497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 36.25C0 38.3203 1.67969 40 3.75 40H31.25C33.3203 40 35 38.3203 35 36.25V15H0V36.25ZM5 21.25C5 20.5625 5.5625 20 6.25 20H28.75C29.4375 20 30 20.5625 30 21.25V26.25C30 26.9375 29.4375 27.5 28.75 27.5H6.25C5.5625 27.5 5 26.9375 5 26.25V21.25ZM31.25 5H27.5V1.25C27.5 0.5625 26.9375 0 26.25 0H23.75C23.0625 0 22.5 0.5625 22.5 1.25V5H12.5V1.25C12.5 0.5625 11.9375 0 11.25 0H8.75C8.0625 0 7.5 0.5625 7.5 1.25V5H3.75C1.67969 5 0 6.67969 0 8.75V12.5H35V8.75C35 6.67969 33.3203 5 31.25 5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_15497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWeek);
export default __webpack_public_path__ + "static/media/calendarWeek.0a925750a59a74e518a6a76e5711392d.svg";
export { ForwardRef as ReactComponent };